import { useCallback, useEffect, useState } from "react";
import { OFFLINE_CRS_ID } from "../../../constants";
import { formatDate } from "../../../constants/utils";
import { INIT_FORM_VALUE, cancelledData, searchFields } from "../utils";
import { createInitialFilters } from "../constants";

const useResReportForm = ({ selectedProperty }) => {
  const [isEdit, setIsEdit] = useState(true);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [formValue, setFormValue] = useState(INIT_FORM_VALUE);
  const [filters, setFilters] = useState(createInitialFilters);
  const [filteredFields, setFilteredFields] = useState([]);
  const [isUploadSidePanelOpen, setIsUploadSidePanelOpen] = useState(false);
  // Bumped on every Search click. The report fetch effect keys on it so a
  // re-search with UNCHANGED criteria still hits the API — without it the
  // effect's other deps (form value, page, filters) are identical and the
  // table silently keeps the previous result set, showing stale status/rates
  // after a reservation was cancelled or modified elsewhere (EO-1895 bug).
  const [searchTrigger, setSearchTrigger] = useState(0);
  const isOffline = selectedProperty.crsId === OFFLINE_CRS_ID;

  useEffect(() => {
    setIsEdit(true);
    setFilters(createInitialFilters());
  }, [selectedProperty]);

  const formSubmitted = useCallback((formValues) => {
    setIsEdit(false);
    setIsDrawerOpen(false);
    setSearchTrigger((trigger) => trigger + 1);
    const searchedFields = [];
    for (const key in formValues) {
      if (formValues[key]) {
        let val = formValues[key];
        if (key === "cancelledReservation") {
          val = cancelledData[formValues[key]].label;
        }
        if (["checkIn", "checkOut", "bookingDate"].includes(key)) {
          val = `${formatDate(formValues[key][0])} - ${formatDate(formValues[key][1])}`;
        }
        const obj = { ...searchFields[key], value: val };
        searchedFields.push(obj);
      }
    }
    setFilteredFields(searchedFields);
  }, []);

  return {
    isEdit,
    setIsEdit,
    isDrawerOpen,
    setIsDrawerOpen,
    formValue,
    setFormValue,
    filters,
    setFilters,
    filteredFields,
    isUploadSidePanelOpen,
    setIsUploadSidePanelOpen,
    isOffline,
    formSubmitted,
    searchTrigger,
  };
};

export default useResReportForm;
